import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { Work } from './pages/Work';
import { CreativeDirection } from './pages/CreativeDirection';
import { Architecture } from './pages/Architecture';
import { UXUIDesign } from './pages/UXUIDesign';
import { Art } from './pages/Art';
import { AleksandroNevsky } from './pages/AleksandroNevsky';
import { BioMaxing } from './pages/BioMaxing';
import { CoLab } from './pages/CoLab';
import { TransformerTheatre } from './pages/TransformerTheatre';
import { Fizkultura } from './pages/Fizkultura';
import { MariinskyTheatre } from './pages/MariinskyTheatre';
import { CoLiving } from './pages/CoLiving';
import { ANMWebsite } from './pages/ANMWebsite';
import { Expressive } from './pages/Expressive';
import { Commission } from './pages/Commission';
import { Academic } from './pages/Academic';
import { Sketching } from './pages/Sketching';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Home data-id="element-3" />} data-id="element-2" />
        <Route path="/work" element={<Work data-id="element-5" />} data-id="element-4" />
        <Route path="/creative-direction" element={<CreativeDirection data-id="element-7" />} data-id="element-6" />
        <Route path="/architecture" element={<Architecture data-id="element-9" />} data-id="element-8" />
        <Route path="/ux-ui-design" element={<UXUIDesign data-id="element-11" />} data-id="element-10" />
        <Route path="/art" element={<Art data-id="element-13" />} data-id="element-12" />
        <Route path="/projects/aleksandro-nevsky" element={<AleksandroNevsky data-id="element-15" />} data-id="element-14" />
        <Route path="/projects/biomaxing" element={<BioMaxing data-id="element-17" />} data-id="element-16" />
        <Route path="/projects/co-lab" element={<CoLab data-id="element-19" />} data-id="element-18" />
        <Route path="/projects/transformer-theatre" element={<TransformerTheatre data-id="element-21" />} data-id="element-20" />
        <Route path="/projects/fizkultura" element={<Fizkultura data-id="element-23" />} data-id="element-22" />
        <Route path="/projects/mariinsky-theatre" element={<MariinskyTheatre data-id="element-25" />} data-id="element-24" />
        <Route path="/projects/co-living" element={<CoLiving data-id="element-27" />} data-id="element-26" />
        <Route path="/projects/anm-website" element={<ANMWebsite data-id="element-29" />} data-id="element-28" />
        <Route path="/projects/expressive" element={<Expressive data-id="element-31" />} data-id="element-30" />
        <Route path="/projects/commission" element={<Commission data-id="element-33" />} data-id="element-32" />
        <Route path="/projects/academic" element={<Academic data-id="element-35" />} data-id="element-34" />
        <Route path="/projects/sketching" element={<Sketching data-id="element-37" />} data-id="element-36" />
      </Routes>
    </BrowserRouter>;
}